import {PlayerBase} from "../../player/player.base";
import {IElectronService} from "../../interfaces/IElectronService";
import {Component, Injector} from '@angular/core';
import {IExtApp} from '../../interfaces/IExtApp';
import {Observable, of, switchMap, takeUntil} from 'rxjs';
import {lastMap} from "../../rxjs/lastMap";
import {catchError, tap} from "rxjs/operators";
import {Log} from "../../services/Log";

@Component({
  selector: 'app-ext-app',
  template: '<div #component>Ext</div>',
  styleUrls: []
})
export class ExtAppComponent extends PlayerBase {
  extApp: IExtApp;

  constructor(protected  injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        this.showMsg(playerObject.$.label, this.NO_PREVIEW);
        return of(null);

        const appName = atob(this.data.ExtApp[0].$.appName64);
        const layout = this.data.Layout[0].$;


        this.extApp = (<IElectronService><Object>this.playerService).createExtApp(appName);
        if (this.extApp != null) {
          this.extApp.setPos(this.posX, this.posY, this.actualWidth, this.actualHeight);
        }

        return of('a');
      }),
      catchError( err => this.logError(err) ),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }


  destroy(): void {
    if (this.extApp != null) {
      (<IElectronService><Object>this.playerService).removeExtApp(this.extApp);
    }
  }

}
